const CAP26 = {
  "id": 49,
  "title": "Impuestos de Bitcoin en México",
  "slug": "impuestos-de-bitcoin-en-mexico",
  "type": "lesson",
  "category": "bitcoin",
  "level": "basic",
  "sections": [
    {
      "heading": "Introducción: Bitcoin y el SAT en México",
      "text": [
        "En México, Bitcoin y otras criptomonedas no se consideran \"moneda de curso legal\", pero sí se tratan como activos digitales o activos virtuales.",
        "Esto significa que, cuando ganas dinero con Bitcoin (por ejemplo, comprando barato y vendiendo caro, o recibiendo pagos en BTC por tus servicios), esas ganancias pueden generar obligaciones fiscales ante el SAT.",
        "Aunque todavía no existe una ley única específica solo para criptomonedas, el SAT y otras autoridades han ido aclarando que las operaciones con cripto se deben declarar igual que otras inversiones o enajenación de bienes."
      ]
    },
    {
      "heading": "Marco general: activos virtuales y obligación de declarar",
      "text": [
        "La Ley Fintech en México define el concepto de \"activo virtual\" y ahí encajan Bitcoin y muchas criptomonedas.",
        "Para efectos prácticos, el SAT trata las ganancias por criptomonedas como ingresos que pueden estar sujetos al Impuesto Sobre la Renta (ISR).",
        "En general, si obtienes una ganancia al vender, intercambiar o usar criptomonedas, estás obligado a considerar ese ingreso en tu declaración anual, igual que cualquier otra inversión."
      ]
    },
    {
      "heading": "Impuesto Sobre la Renta (ISR) y criptomonedas",
      "text": [
        "El ISR es el impuesto que pagas por tus ingresos. En el caso de Bitcoin, el SAT suele tratar las ganancias como ingresos por la enajenación (venta) de bienes o como parte de tus actividades empresariales/profesionales, según tu caso.",
        "En términos simples: si vendes Bitcoin más caro de lo que lo compraste, tienes una ganancia; si lo vendes más barato, tienes una pérdida."
      ],
      "list": [
        "Compra y venta de Bitcoin: si compras BTC a un precio y luego lo vendes más caro, la diferencia positiva es una ganancia que debe declararse como ingreso y puede pagar ISR.",
        "Intercambio cripto–cripto: si cambias Bitcoin por otra criptomoneda y en ese momento el valor de tu BTC en pesos es mayor al que pagaste originalmente, también puede generarse una ganancia gravable.",
        "Recibir pagos en Bitcoin: si cobras honorarios, servicios o vendes productos y te pagan en BTC, el valor en pesos en la fecha de cobro se considera ingreso y se integra a tu ISR.",
        "Minería, staking o rendimientos: las recompensas por minar, hacer staking o prestar tus criptos pueden considerarse ingresos y, por lo tanto, también entran al cálculo del ISR."
      ]
    },
    {
      "heading": "¿Y si solo guardo mis Bitcoin?",
      "text": [
        "Si solo compras Bitcoin y los mantienes guardados (HODL), sin venderlos ni cambiarlos, en principio no se considera que haya una ganancia realizada.",
        "Mientras no vendas, intercambies o uses tus BTC para pagar algo, no se materializa la ganancia o pérdida y normalmente no se genera ISR por esa tenencia.",
        "Sin embargo, es importante llevar un registro de fechas, precios de compra y movimientos para poder calcular correctamente las ganancias o pérdidas cuando sí hagas operaciones."
      ]
    },
    {
      "heading": "IVA (Impuesto al Valor Agregado) y Bitcoin",
      "text": [
        "En México, la compraventa directa de criptomonedas (por ejemplo, comprar o vender Bitcoin en un exchange) generalmente no causa IVA sobre el valor del Bitcoin en sí.",
        "Sin embargo, sí puede haber IVA en las comisiones que te cobra la plataforma o el intermediario por la operación.",
        "Cuando vendes bienes o servicios y cobras en criptomonedas, el IVA funciona igual que si cobraras en pesos: si tu actividad normalmente lleva IVA, lo debes cobrar y enterar al SAT, independientemente de si el cliente te paga en MXN, BTC u otra cripto."
      ],
      "list": [
        "Compra/venta de Bitcoin: normalmente sin IVA sobre el valor del BTC.",
        "Comisiones de exchanges/plataformas: pueden llevar IVA (por ejemplo, 16% sobre la comisión).",
        "Venta de bienes y servicios cobrando en BTC: el IVA se calcula sobre el valor en pesos del bien o servicio."
      ]
    },
    {
      "heading": "Impuestos sobre el patrimonio y tenencia",
      "text": [
        "A diferencia de otros países, en México no existe un impuesto general al patrimonio como el que se aplica en algunos países europeos.",
        "Aun así, tus Bitcoin forman parte de tu patrimonio y deben considerarse dentro de tu situación fiscal global (por ejemplo, para temas de contabilidad en empresas, declaraciones informativas, etc.).",
        "Si manejas volúmenes grandes o eres persona moral, es importante registrar los criptoactivos en tu contabilidad con su valor en pesos."
      ]
    },
    {
      "heading": "¿Qué pasa si pierdo dinero con Bitcoin?",
      "text": [
        "En el mundo real, las inversiones no siempre salen bien: también puedes perder. Lo importante es entender cómo se pueden tratar fiscalmente esas pérdidas.",
        "Dependiendo del régimen en que tributes y de la forma en que declares tus operaciones, en algunos casos las pérdidas pueden compensarse contra otras ganancias de capital o ingresos de la misma naturaleza.",
        "La idea general es que se intente pagar ISR sobre el beneficio real neto, no sobre cifras infladas que no consideran las pérdidas, pero las reglas concretas son técnicas y es fácil equivocarse."
      ]
    },
    {
      "heading": "Recomendaciones prácticas para México",
      "list": [
        "Lleva un registro detallado de todas tus operaciones: fechas, precios en pesos, comisiones, entradas y salidas.",
        "Identifica qué tipo de ingreso tienes: compraventa, servicios cobrados en BTC, minería, staking, etc.",
        "No asumas que porque es \"cripto\" el SAT no se entera o no le interesa: las plataformas cada vez están más reguladas.",
        "En montos pequeños, aprende y practica; en montos grandes, asesórate con un contador o fiscalista que conozca cripto.",
        "Revisa cada año si tus operaciones deben incluirse en tu declaración anual de ISR."
      ]
    },
    {
      "heading": "Mensaje final",
      "text": [
        "La regulación en torno a Bitcoin y las criptomonedas en México sigue evolucionando. Lo importante es entender que, para el SAT, las ganancias con Bitcoin se consideran ingresos y pueden generar impuestos.",
        "Esta lección es una guía general para que tengas claridad de los conceptos básicos, pero no sustituye la opinión de un profesional.",
        "Siempre que tengas dudas específicas sobre tu caso (montos, tipo de operación, régimen fiscal), consulta con un asesor fiscal o contador especializado en criptomonedas."
      ]
    }
  ]
};

export default CAP26;
